// extracted by mini-css-extract-plugin
export default {"title":"styles_title__Dnkze","wrapper-form":"styles_wrapper-form__yi41Z","wraper-phone":"styles_wraper-phone__NfFXw"};